import React from "react";
import moment from "moment";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";

import { useContext, useState, useEffect, useRef } from "react";
import { ChartContext } from "../../../Context/ChartContext/ChartContext";
import MainContext from "../../../Context/MainContext/MainContext";

import MUIButton from "@mui/material/Button";
import MUIGrid from "@mui/material/Grid";
import MUITextField from "@mui/material/TextField";
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUIPaper from "@mui/material/Paper";
import MUITable from "@mui/material/Table";
import MUITableContainer from "@mui/material/TableContainer";
import MUITableRow from "@mui/material/TableRow";
import MUITableCell from "@mui/material/TableCell";
import MUITableHead from "@mui/material/TableHead";
import MUITableBody from "@mui/material/TableBody";
import MUITypography from "@mui/material/Typography";
import MUIMenuItem from "@mui/material/MenuItem";
import MUIListItemIcon from "@mui/material/ListItemIcon";
import MUIUpgradeIcon from "@mui/icons-material/Upgrade";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUILocalShippingIcon from "@mui/icons-material/LocalShipping";
import MUIBackspaceIcon from "@mui/icons-material/Backspace";
import MUIBox from "@mui/material/Box";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUICheckbox from "@mui/material/Checkbox";
import MUICollapse from "@mui/material/Collapse";
import MUIStack from "@mui/material/Stack";
import MUIAlert from "@mui/material/Alert";
import MUIIconButton from "@mui/material/IconButton";
import MUIFileDownloadIcon from "@mui/icons-material/FileDownload";
import MUIChip from "@mui/material/Chip";
import MUIAccessibleIcon from "@mui/icons-material/Accessible";
import MUIEventSeatIcon from "@mui/icons-material/EventSeat";
import MUIWidgetIcon from "@mui/icons-material/Widgets";
import MUIPowerIcon from "@mui/icons-material/Power";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIArrowBackIcon from "@mui/icons-material/ArrowBack";
import MUIAutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import MUICheckIcon from "@mui/icons-material/Check";
import MUIInputAdornment from "@mui/material/InputAdornment";
import MUIDoneAllIcon from "@mui/icons-material/DoneAll";
import MUIInventoryIcon from "@mui/icons-material/Inventory";
import MUIRequestQuoteIcon from "@mui/icons-material/RequestQuote";
import MUITooltip from "@mui/material/Tooltip";
import MUIFilterAltIcon from "@mui/icons-material/FilterAlt";
import MUIFilterAltOffIcon from "@mui/icons-material/FilterAltOff";

import Card from "../../Card";
import Menu from "../../Menu";
import EmptyState from "../../EmptyState";
import TileUploadedFile from "../../Tile/TileUploadedFile";
import UploadedFile from "../../../Utility/Crud/UploadedFile";
import OrderActivity from "../../../Utility/Crud/OrderActivity";
import Setting from "../../../Utility/Setting";
import Patient from "../../../Utility/Crud/Patient";
import Security from "../../../Utility/Security";
import BtProduct from "../../../Utility/Crud/BtProduct";
import DialogUploadQuote from "../../Dialog/DialogUploadQuote";

import PdfDswo from "../../../Utility/Pdf/PdfDswo";
import ProductSubType from "../../../Utility/Crud/ProductSubType";
import Product from "../../../Utility/Crud/Product";
import ProductType from "../../../Utility/Crud/ProductType";
import RuleEngine from "../../../Utility/RuleEngine/RuleEngine";
import InfoItem from "../../InfoItem";
import Throttle from "../../../Utility/Throttle";
import api from "../../../Seating/Security/api";
import Vendor from "../../../Utility/Crud/Vendor";
import BaseUnit from "../../../Utility/Crud/BaseUnit";
import File from "../../../Utility/File";

/**
 * CardChartOrderEquipment renders a Card component
 * displaying order equipment (products) data.
 * @returns {JSX.Element}
 */

const title = "Order Equipment";
const icon = MUIAccessibleIcon;

const className = "CardChartOrderEquipment";

export default function CardChartOrderEquipment(props) {
  const chartContext = useContext(ChartContext);
  const mainContext = useContext(MainContext);
  const inputRef = useRef();
  const previousOrderIdRef = useRef(chartContext.orderId);
  const previousInsuranceTypeIdRef = useRef(
    chartContext.chart.orderActivity[chartContext.orderId]?.insuranceTypeId,
  );
  const patientResponsibilityAtEditStartRef = useRef(null);
  const lastEquipmentSetPatientResponsibilityRef = useRef(null);
  const equipmentTouchedPatientResponsibilityRef = useRef(false);

  const [editMode, setEditMode] = useState(false);
  const [selectedProductType, setSelectedProductType] = useState(null);
  const [selectedProductSubType, setSelectedProductSubType] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const [cardChart, setCardChart] = useState(null);
  const [cashAmountDrafts, setCashAmountDrafts] = useState({});

  const [sortedOrderProducts, setSortedOrderProducts] = useState([]);
  const [modifiedProducts, setModifiedProducts] = useState([]);
  const [parentProductIds, setParentProductIds] = useState([]);

  const [btProductsFound, setBtProductsFound] = useState({});
  const orderActivity = chartContext.chart.orderActivity[chartContext.orderId];
  const orderActivityApproval = Object.values(
    chartContext.chart.orderActivityApprovals || {},
  ).find(
    (orderActivityApproval) =>
      orderActivityApproval.orderActivityId === chartContext.orderId,
  );
  const approvalId = orderActivityApproval?.approvalsId;

  const [abnAmountInput, setAbnAmountInput] = useState(orderActivity.abnAmount);

  const originalProducts = OrderActivity.getProducts(
    orderActivity,
    chartContext.originalChart,
  );

  const activityFilesQuote = Object.values(
    chartContext.chart.activityFile,
  ).filter(
    (activityFile) =>
      activityFile.activityId === chartContext.orderId &&
      activityFile.activityFileTypeTermId === 151 &&
      !activityFile.deleted,
  );
  const uploadedFiles = Object.values(chartContext.chart.uploadedFile).filter(
    (uploadedFile) =>
      activityFilesQuote.some(
        (activityFile) => activityFile.fileId === uploadedFile.id,
      ),
  );

  const [productUpgradeOpen, setProductUpgradeOpen] = useState(false);
  const [indexOfProductBeingUpgraded, setIndexOfProductBeingUpgraded] =
    useState(null);
  const [showUpgradeToAnything, setShowUpgradeToAnything] = useState(false);

  const [receiveProductOpen, setReceiveProductOpen] = useState(false);
  const [indexOfProductBeingReceived, setIndexOfProductBeingReceived] =
    useState(null);
  const [productBeingReceived, setProductBeingReceived] = useState(null);

  const [selectedReceiveProductVendor, setSelectedReceiveProductVendor] =
    useState(null);

  const [uploadQuoteDialogOpen, setUploadQuoteDialogOpen] = useState(false);
  const [uploadQuoteData, setUploadQuoteData] = useState(null);
  const [uploadingQuote, setUploadingQuote] = useState(false);
  const [originalUploadQuoteFileId, setOriginalUploadQuoteFileId] =
    useState(null);
  const [addingOrderProducts, setAddingOrderProducts] = useState(false);
  const [shouldSave, setShouldSave] = useState(false);

  const [showPointsDoNotMatchAlert, setShowPointsDoNotMatchAlert] =
    useState(false);

  const showPointsColumn =
    props.showPointsColumn !== undefined ? props.showPointsColumn : true;
  const showBrightreeColumn =
    props.showBrightreeColumn !== undefined ? props.showBrightreeColumn : true;
  const showRentalColumn =
    props.showRentalColumn !== undefined ? props.showRentalColumn : true;
  const showApprovedColumn =
    props.showApprovedColumn !== undefined ? props.showApprovedColumn : true;
  const showAbnColumn =
    props.showAbnColumn !== undefined ? props.showAbnColumn : true;
  const showDeliveredColumn =
    props.showDeliveredColumn !== undefined ? props.showDeliveredColumn : true;
  const allowApproving =
    props.allowApproving !== undefined ? props.allowApproving : true;
  const allowToggleAbn =
    props.allowToggleAbn !== undefined ? props.allowToggleAbn : true;
  const showGenerateDswoButton =
    props.showGenerateDswoButton !== undefined
      ? props.showGenerateDswoButton
      : true;
  const isOrderApproved = Boolean(orderActivity?.isApproved);
  const allowAdding =
    (props.allowAdding !== undefined ? props.allowAdding : true) &&
    orderActivity?.status !== 3 &&
    !isOrderApproved;

  const getCashPatientResponsibilityAmount = (productPatch = {}) => {
    const currentProducts = OrderActivity.getProducts(
      orderActivity,
      chartContext.chart,
    ).filter((product) => !product.deleted && product.billable === true);

    const currentProductIds = new Set(
      currentProducts.map((product) => product.id),
    );

    let totalCharges = currentProducts.reduce((sum, product) => {
      const patchedProduct = Object.prototype.hasOwnProperty.call(
        productPatch,
        product.id,
      )
        ? { ...product, ...productPatch[product.id] }
        : product;

      if (patchedProduct.deleted || patchedProduct.billable !== true) {
        return sum;
      }

      return (
        sum +
        Number(patchedProduct.amount || 0) * Number(patchedProduct.qty || 0)
      );
    }, 0);

    Object.entries(productPatch).forEach(([productId, patch]) => {
      const numericProductId = Number(productId);
      if (currentProductIds.has(numericProductId) || !patch) {
        return;
      }
      const existingProduct =
        chartContext.chart.product?.[numericProductId] || {};
      const patchedProduct = { ...existingProduct, ...patch };

      if (patchedProduct.deleted || patchedProduct.billable !== true) {
        return;
      }

      totalCharges +=
        Number(patchedProduct.amount || 0) * Number(patchedProduct.qty || 0);
    });

    totalCharges = Number(totalCharges.toFixed(2));
    return totalCharges;
  };

  const resetEquipmentPatientResponsibilityTracking = () => {
    patientResponsibilityAtEditStartRef.current = null;
    lastEquipmentSetPatientResponsibilityRef.current = null;
    equipmentTouchedPatientResponsibilityRef.current = false;
    setCashAmountDrafts({});
  };

  const beginEquipmentEditSession = () => {
    patientResponsibilityAtEditStartRef.current = approvalId
      ? (chartContext.chart.approval?.[approvalId]?.patientResponsibility ??
        null)
      : null;
    lastEquipmentSetPatientResponsibilityRef.current = null;
    equipmentTouchedPatientResponsibilityRef.current = false;
  };

  const getEquipmentPatientResponsibilityUpdate = (productPatch = {}) => {
    if (!approvalId) {
      return null;
    }

    if (!equipmentTouchedPatientResponsibilityRef.current) {
      patientResponsibilityAtEditStartRef.current =
        chartContext.chart.approval?.[approvalId]?.patientResponsibility ??
        null;
    }

    const patientResponsibility =
      orderActivity?.insuranceTypeId === 4
        ? getCashPatientResponsibilityAmount(productPatch)
        : null;
    lastEquipmentSetPatientResponsibilityRef.current = patientResponsibility;
    equipmentTouchedPatientResponsibilityRef.current = true;

    return {
      approval: {
        [approvalId]: {
          patientResponsibility: patientResponsibility,
        },
      },
    };
  };

  // Always show ABN fields in edit mode, but disable if no product has abnRequired
  const hasAbnRequired = (
    editMode ? modifiedProducts : sortedOrderProducts
  ).some((p) => p.abnRequired);

  const editableProductTypeIds = [
    1, // Standard MWC
    2, // Standard PWC
    3, // Complex PWC
    10, // Complex MWC
    11, // POV
    13, // Bed
    15, // Complex Base Only
    25, // Coushion/Overlay
    33, // Complex - Group 2
  ];

  const ruleEngineResults = {
    GROUP_3_DX_REQUIRED_FOR_BILLABLE_HCPCS_TO_ENABLE_DSWO_BUTTON:
      RuleEngine.evaluate(
        RuleEngine.rules
          .GROUP_3_DX_REQUIRED_FOR_BILLABLE_HCPCS_TO_ENABLE_DSWO_BUTTON,
        chartContext.originalChart,
        chartContext.originalChart,
        chartContext.orderId,
        "component",
      ),
    APPROVED_INSURANCE_REQUIRED_TO_ENABLE_DSWO_BUTTON: RuleEngine.evaluate(
      RuleEngine.rules.APPROVED_INSURANCE_REQUIRED_TO_ENABLE_DSWO_BUTTON,
      chartContext.originalChart,
      chartContext.originalChart,
      chartContext.orderId,
      "component",
    ),
    E1028_HCPCS_REQUIRED_TO_ENABLE_DSWO_BUTTON: RuleEngine.evaluate(
      RuleEngine.rules.E1028_HCPCS_REQUIRED_TO_ENABLE_DSWO_BUTTON,
      chartContext.originalChart,
      chartContext.originalChart,
      chartContext.orderId,
      "component",
    ),
    E1028_NOT_ALLOWED_TO_ENABLE_DSWO_BUTTON: RuleEngine.evaluate(
      RuleEngine.rules.E1028_NOT_ALLOWED_TO_ENABLE_DSWO_BUTTON,
      chartContext.originalChart,
      chartContext.originalChart,
      chartContext.orderId,
      "component",
    ),
  };

  const dswoAlertMessages = [];
  if (
    !ruleEngineResults
      ?.GROUP_3_DX_REQUIRED_FOR_BILLABLE_HCPCS_TO_ENABLE_DSWO_BUTTON?.passed
  ) {
    dswoAlertMessages.push(
      ruleEngineResults
        ?.GROUP_3_DX_REQUIRED_FOR_BILLABLE_HCPCS_TO_ENABLE_DSWO_BUTTON?.message,
    );
  }
  if (
    !ruleEngineResults?.APPROVED_INSURANCE_REQUIRED_TO_ENABLE_DSWO_BUTTON
      ?.passed
  ) {
    dswoAlertMessages.push(
      ruleEngineResults?.APPROVED_INSURANCE_REQUIRED_TO_ENABLE_DSWO_BUTTON
        ?.message,
    );
  }
  if (!ruleEngineResults?.E1028_HCPCS_REQUIRED_TO_ENABLE_DSWO_BUTTON?.passed) {
    dswoAlertMessages.push(
      ruleEngineResults?.E1028_HCPCS_REQUIRED_TO_ENABLE_DSWO_BUTTON?.message,
    );
  }
  if (!ruleEngineResults?.E1028_NOT_ALLOWED_TO_ENABLE_DSWO_BUTTON?.passed) {
    dswoAlertMessages.push(
      ruleEngineResults?.E1028_NOT_ALLOWED_TO_ENABLE_DSWO_BUTTON?.message,
    );
  }

  const enableGenerateDswoButton =
    ruleEngineResults
      ?.GROUP_3_DX_REQUIRED_FOR_BILLABLE_HCPCS_TO_ENABLE_DSWO_BUTTON?.passed &&
    ruleEngineResults?.APPROVED_INSURANCE_REQUIRED_TO_ENABLE_DSWO_BUTTON
      ?.passed &&
    ruleEngineResults?.E1028_HCPCS_REQUIRED_TO_ENABLE_DSWO_BUTTON?.passed &&
    ruleEngineResults?.E1028_NOT_ALLOWED_TO_ENABLE_DSWO_BUTTON?.passed;

  useEffect(() => {
    const previousOrderId = previousOrderIdRef.current;
    const currentOrderId = chartContext.orderId;
    const previousInsuranceTypeId = previousInsuranceTypeIdRef.current;
    const currentInsuranceTypeId = orderActivity?.insuranceTypeId;

    if (previousOrderId !== currentOrderId) {
      previousOrderIdRef.current = currentOrderId;
      previousInsuranceTypeIdRef.current = currentInsuranceTypeId;
      setCashAmountDrafts({});
      return;
    }

    if (previousInsuranceTypeId === currentInsuranceTypeId) {
      return;
    }

    previousInsuranceTypeIdRef.current = currentInsuranceTypeId;

    const productUpdates = {};
    const currentProducts = OrderActivity.getProducts(
      orderActivity,
      chartContext.chart,
    ).filter((product) => !product.deleted);

    currentProducts.forEach((product) => {
      const updatedProduct = {};
      const calculatedPoints = Product.getPoints(
        mainContext.productSubTypesIndexed[product.productSubTypeId],
        currentInsuranceTypeId,
        mainContext.insuranceMatrixEntriesIndexed,
        mainContext.productMatrixEntriesIndexed,
        product,
      );
      if (product.points !== calculatedPoints) {
        updatedProduct.points = calculatedPoints;
      }

      const amount = Product.getAmount(
        product.hcpcs, //hcpcs code
        product?.isRental, //isRental
        mainContext.hcpcsCodesIndexed,
        mainContext.feeSchedulesIndexed,
      );

      if (amount !== null && product.amount !== amount) {
        updatedProduct.amount = amount;
      } else if (amount === null && product.amount !== null) {
        updatedProduct.amount = null;
      }

      if (Object.keys(updatedProduct).length > 0) {
        productUpdates[product.id] = updatedProduct;
      }
    });

    const updates = {};
    if (Object.keys(productUpdates).length > 0) {
      updates.product = productUpdates;
    }

    if (approvalId) {
      updates.approval = {
        [approvalId]: {
          patientResponsibility:
            currentInsuranceTypeId === 4
              ? getCashPatientResponsibilityAmount(productUpdates)
              : null,
        },
      };
    }

    if (Object.keys(updates).length > 0) {
      chartContext.onChange(updates);
    }
  }, [chartContext.orderId, orderActivity?.insuranceTypeId]);

  useEffect(() => {
    if (editMode) {
      const orderActivityApprovals = Object.values(
        chartContext.chart.orderActivityApprovals || {},
      ).find(
        (orderActivityApproval) =>
          orderActivityApproval.orderActivityId === chartContext.orderId,
      );
      const approvalId = orderActivityApprovals?.approvalsId;

      const rules = [
        {
          target: "product",
          id: productBeingReceived?.id,
          field: "baseUnitId",
          rule: {
            required:
              productBeingReceived &&
              mainContext.productTypesIndexed[
                productBeingReceived.productTypeId
              ]?.requiresSerialNumber,
          },
        },
        {
          target: "product",
          id: productBeingReceived?.id,
          field: "serial",
          rule: {
            required:
              productBeingReceived &&
              mainContext.productTypesIndexed[
                productBeingReceived.productTypeId
              ]?.requiresSerialNumber,
          },
        },
        {
          target: "orderActivity",
          id: orderActivity.id,
          field: "abnAmount",
          rule: {
            required: hasAbnRequired,
          },
        },
      ];

      if (approvalId) {
        rules.push({
          target: "approval",
          id: approvalId,
          field: "abnRequiredNote",
          rule: {
            required: hasAbnRequired,
          },
        });
      }

      chartContext.updateValidationRules({
        key: className,
        rules: rules,
      });
    } else {
      chartContext.updateValidationRules({ key: className, rules: [] });
    }
  }, [productBeingReceived, hasAbnRequired, editMode]);

  // Reset card "save" is clicked
  useEffect(() => {
    setEditMode(false);
    setModifiedProducts(sortedOrderProducts);
    setSelectedProductType(null);
    setProductUpgradeOpen(false);
    setIndexOfProductBeingUpgraded(null);
    setShowUpgradeToAnything(false);
    setReceiveProductOpen(false);
    setIndexOfProductBeingReceived(null);
    setSelectedReceiveProductVendor(null);
    resetEquipmentPatientResponsibilityTracking();
  }, [chartContext.originalChart]);

  // Sync this card's edit mode with ChartContext for ChartNavigationBar display
  useEffect(() => {
    chartContext.setCardEditMode?.(className, editMode);
    return () => chartContext.setCardEditMode?.(className, false);
  }, [editMode, chartContext.setCardEditMode]);

  /**
   * Updates and sorts the order products array based on the original order
   * products. Groups products with their upgrades, placing the primary
   * product first, followed by other products sorted by points in descending
   * order.
   */
  useEffect(() => {
    // 1. Sorting helpers
    function sortGroups(groups) {
      return groups.sort((groupA, groupB) => {
        const mainA = groupA[groupA.length - 1];
        const mainB = groupB[groupB.length - 1];

        // Primary product first
        if (mainA.id === primaryProduct?.id) {
          return -1;
        }
        if (mainB.id === primaryProduct?.id) {
          return 1;
        }

        // Points descending
        const pointsA = mainA.points || 0;
        const pointsB = mainB.points || 0;

        if (pointsB !== pointsA) {
          return pointsB - pointsA;
        }

        // ProductTypeId grouping for tied points
        const typeA = mainA.productTypeId || 0;
        const typeB = mainB.productTypeId || 0;

        if (typeA !== typeB) {
          return typeA - typeB;
        }

        // Stable fallback: ID ascending
        return mainA.id - mainB.id;
      });
    }

    function groupIsDelivered(group) {
      return group.some((product) => isProductDelivered(product));
    }

    const primaryProduct = OrderActivity.getPrimaryProduct(originalProducts);
    const productMap = new Map(
      originalProducts.map((product) => [product.id, product]),
    );

    // 2. Group upgrade + parent
    const groupedProducts = [];
    const visitedIds = new Set();

    for (const product of originalProducts) {
      if (visitedIds.has(product.id)) {
        continue;
      }

      if (product.upgradedFromProductId) {
        const parent = productMap.get(product.upgradedFromProductId);

        if (parent) {
          groupedProducts.push([product, parent]); // upgrade first, parent second
          visitedIds.add(product.id);
          visitedIds.add(parent.id);
          continue;
        }
      }
      // solo product
      groupedProducts.push([product]);
      visitedIds.add(product.id);
    }

    // 3. Determine if a group is delivered (either product delivered = true)
    const deliveredGroups = [];
    const nonDeliveredGroups = [];

    for (const group of groupedProducts) {
      if (groupIsDelivered(group)) {
        deliveredGroups.push(group);
      } else {
        nonDeliveredGroups.push(group);
      }
    }

    // 4. Sort each section independently
    const sortedDelivered = sortGroups(deliveredGroups);
    const sortedNonDelivered = sortGroups(nonDeliveredGroups);

    // 5. Concatenate delivered → non-delivered
    const finalGroups = [...sortedDelivered, ...sortedNonDelivered];

    // 6. Flatten back into product array
    const sortedProducts = finalGroups.flat();

    setSortedOrderProducts(sortedProducts);

    // 6. Check if any product points do not match calculated points
    if (
      sortedProducts.some(
        (product) =>
          product.points !==
            Product.getPoints(
              mainContext.productSubTypesIndexed[product.productSubTypeId],
              orderActivity.insuranceTypeId,
              mainContext.insuranceMatrixEntriesIndexed,
              mainContext.productMatrixEntriesIndexed,
              product,
            ) && orderActivity?.status < 3,
      )
    ) {
      setShowPointsDoNotMatchAlert(true);
    } else {
      setShowPointsDoNotMatchAlert(false);
    }

    // 8. Initialize btProductsFound
    const initialBtProductsFound = {};
    sortedProducts.forEach((product) => {
      if (product.btitemId) {
        initialBtProductsFound[product.id] = [{ itemId: product.btitemId }];
      } else {
        initialBtProductsFound[product.id] = [];
      }
    });

    setBtProductsFound(initialBtProductsFound);
  }, [chartContext.originalChart]);

  /**
   * Updates the modified products array to match the order products array.
   * Sorts products to match sortedOrderProducts order - DO NOT sort by points
   * becdause we mutate points direclty in chartContext.chart
   */
  useEffect(() => {
    const products = OrderActivity.getProducts(
      orderActivity,
      chartContext.chart,
    ).filter((product) => !product.deleted && !product.selectedUpgrade);

    const orderProductsMap = new Map(
      sortedOrderProducts.map((p, index) => [p.id, index]),
    );

    const sortedProducts = [...products].sort((a, b) => {
      const aIndex = orderProductsMap.get(a.id) ?? Number.MAX_VALUE;
      const bIndex = orderProductsMap.get(b.id) ?? Number.MAX_VALUE;
      return aIndex - bIndex;
    });

    setModifiedProducts(sortedProducts);
  }, [chartContext.chart, sortedOrderProducts]);

  /**
   * Updates the parent product ids array to include the upgraded from product
   * ids.
   */
  useEffect(() => {
    const parentProductIds = sortedOrderProducts
      ?.filter((product) => product.upgradedFromProductId)
      .map((product) => product.upgradedFromProductId);

    setParentProductIds(parentProductIds);
  }, [sortedOrderProducts]);

  /**
   * Throttled function to handle btproduct search input changes.
   * Limits the frequency of API calls to once every 100 milliseconds.
   * @param {string} code - The btproduct or search term being searched.
   */
  const throttledHandleBtProductSearch = Throttle.throttle(
    (omniSearchTerm, product) => {
      handleBtproductChange(omniSearchTerm, product);
    },
    100,
    { trailing: true },
  );

  /**
   * Returns all purchase queue rows for a given quote file.
   * @param {number} quoteFileId
   * @returns {Array}
   */
  const getPurchaseQueuesForQuoteFile = (quoteFileId) => {
    return Object.values(chartContext.chart.purchaseQueue || {}).filter(
      (purchaseQueue) =>
        purchaseQueue.quoteId === quoteFileId &&
        purchaseQueue.orderId === chartContext.orderId &&
        !purchaseQueue.deleted,
    );
  };

  /**
   * Handles changes to the btproduct search input.
   * Sends a POST request to fetch btproducts matching the search term.
   * Updates the btProductsFound state with the results.
   * @param {string} omniSearchTerm - The btproduct search term.
   */
  const handleBtproductChange = (omniSearchTerm, product) => {
    const args = { omniSearchTerm: omniSearchTerm, recordLimit: 20 };
    if (product.hcpcs) {
      args.BtProduct_hcpcs = product.hcpcs;
    }
    api
      .send("POST", `/search/omniSearch/Btproduct`, args, 2, true)
      .then((data) => {
        // Sort results alphabetically by display name
        const sortedBtProducts = (data.btProducts || [])
          .slice()
          .sort((a, b) => {
            const aName = BtProduct.getDisplayName(a) || "";
            const bName = BtProduct.getDisplayName(b) || "";
            return aName.localeCompare(bName, undefined, {
              sensitivity: "base",
            });
          });
        setBtProductsFound((prev) => ({
          ...prev,
          [product.id]: sortedBtProducts,
        }));
      })
      .catch((error) => {
        console.error("Error fetching btproducts:", error);
      });
  };

  /**
   * Renders a dropdown menu for selecting product categories.
   * The dropdown is disabled if the order status is 3 (Setup).
   * @returns {JSX.Element} MUIAutocomplete component for category selection
   */
  const renderCategoryDropdown = () => {
    const getCategoryOptions = () => {
      return ProductType.sort(
        Object.values(mainContext.productTypesIndexed),
      ).map((productType) => ({
        label: productType.name,
        value: productType.id,
      }));
    };
    return (
      <MUIAutocomplete
        options={getCategoryOptions()}
        onChange={(e, newValue) => {
          setSelectedProductType(newValue || null);
        }}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        value={selectedProductType}
        disabled={!allowAdding}
        autoHighlight={true}
        renderInput={(params) => (
          <MUITextField
            {...params}
            InputLabelProps={{ shrink: true }}
            size="small"
            variant="standard"
            label="Category"
            fullWidth
          />
        )}
      />
    );
  };

  /**
   * Renders a dropdown menu for selecting products.
   * The dropdown is disabled if the order status is 3 (Setup).
   * @returns {JSX.Element} MUIAutocomplete component for product selection
   */
  const renderProductDropdown = () => {
    const getProductOptions = () => {
      const productSubTypes = ProductSubType.sort(
        Object.values(mainContext.productSubTypesIndexed),
      );
      const filteredSubTypes = selectedProductType
        ? productSubTypes.filter(
            (productSubType) =>
              productSubType.productTypeId === selectedProductType.value,
          )
        : productSubTypes;

      return filteredSubTypes.map((productSubType, index) => ({
        label:
          productSubType.name +
          (productSubType.hcpcs ? ` - ${productSubType.hcpcs}` : ""),
        value: productSubType.id,
        key: index, // Use ID as key since it should be unique and we have multiple dublicate products
      }));
    };

    const handleAddProduct = (productSubType) => {
      if (productSubType) {
        const selectedProductSubType =
          mainContext.productSubTypesIndexed[productSubType.value];
        const defaultQty =
          selectedProductSubType?.defaultQuantity > 0
            ? selectedProductSubType.defaultQuantity
            : 1;
        const existingProducts = chartContext.chart.product || {};
        const newProductId = chartContext.getNegativeId();
        const products = {
          ...existingProducts,
          [newProductId]: {
            id: newProductId,
            abnRequired: false,
            approved: false,
            hcpcs: selectedProductSubType?.hcpcs || "",
            productSubTypeId: productSubType.value,
            productTypeId: selectedProductSubType?.productTypeId,
            deliverable: true,
            billable: true,
            qty: defaultQty,
            points: Product.getPoints(
              selectedProductSubType,
              orderActivity.insuranceTypeId,
              mainContext.insuranceMatrixEntriesIndexed,
              mainContext.productMatrixEntriesIndexed,
            ),
            serial: "",
            amount:
              Product.getAmount(
                mainContext.productSubTypesIndexed[productSubType.value]
                  .hcpcs || "", //hcpcs code
                false, //isRental
                mainContext.hcpcsCodesIndexed,
                mainContext.feeSchedulesIndexed,
              ) ?? null,
            isRental: false,
            upgradedFromProductId: null,
          },
        };

        const existingOrderProducts =
          chartContext.chart.orderActivityProducts || {};
        const orderActivityProducts = {
          ...existingOrderProducts,
          [newProductId]: {
            orderActivityId: chartContext.orderId,
            productsId: newProductId,
          },
        };

        const approvalUpdate = getEquipmentPatientResponsibilityUpdate({
          [newProductId]: products[newProductId],
        });

        chartContext.onChange({
          ...(approvalUpdate || {}),
          product: products,
          orderActivityProducts: orderActivityProducts,
        });

        NotistackEnqueueSnackbar("Product added", { variant: "success" });
      }
    };

    return (
      <MUIAutocomplete
        options={getProductOptions()}
        value={selectedProductSubType}
        inputValue={inputValue}
        onChange={(e, newValue) => {
          if (newValue) {
            handleAddProduct(newValue);
            inputRef.current?.focus();
          }
          setSelectedProductSubType(null);
          setInputValue("");
        }}
        onInputChange={(e, newValue) => setInputValue(newValue)}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        getOptionKey={(option) => option.key} // Must use this when we have multiple dublicate products to prevent console warnings
        disabled={!allowAdding}
        autoHighlight={true}
        renderInput={(params) => (
          <MUITextField
            {...params}
            inputRef={inputRef}
            InputLabelProps={{ shrink: true }}
            size="small"
            variant="standard"
            label="Product"
            fullWidth
          />
        )}
      />
    );
  };

  /**
   * Returns delivered status for a product by checking deliveryInformation.
   * @param {Object} chartProduct
   * @returns {boolean}
   */
  const isProductDelivered = (chartProduct) => {
    const deliveryRows = Object.values(
      chartContext.chart.deliveryInformation || {},
    ).filter((row) => {
      if (
        row.documentType !== "Equipment Delivery" ||
        row.orderId !== chartContext.orderId
      ) {
        return false;
      }

      try {
        JSON.parse(row.documentInfoPruned);
        return true;
      } catch {
        return false;
      }
    });
    if (deliveryRows.length === 0) {
      return false;
    }

    // Get most recent by uploadedOn
    deliveryRows.sort(
      (a, b) => new Date(b.uploadedOn) - new Date(a.uploadedOn),
    );
    let documentInfoPruned;
    try {
      documentInfoPruned = JSON.parse(deliveryRows[0].documentInfoPruned);
    } catch {
      return false;
    }
    if (!documentInfoPruned.products) {
      return false;
    }

    const foundDeliveryProduct = documentInfoPruned.products.find(
      (deliveryProduct) => deliveryProduct.id === chartProduct.id,
    );
    return !!foundDeliveryProduct?.delivered;
  };

  /**
   * Renders a table of products.
   * @returns {JSX.Element} MUITable component for product table
   */
  const renderProductTable = () => {
    const products = editMode ? modifiedProducts : sortedOrderProducts;

    return (
      <MUITableContainer component={MUIPaper} elevation={0} sx={{ mt: 1 }}>
        <MUITable size="small">
          <MUITableHead
            sx={{
              backgroundColor: (theme) => theme.palette.background.default,
            }}
          >
            <MUITableRow>
              <MUITableCell sx={{ width: "120px" }}>Category</MUITableCell>
              <MUITableCell>Product</MUITableCell>
              <MUITableCell sx={{ width: "80px" }}>HCPCS</MUITableCell>
              <MUITableCell sx={{ width: "75px" }}>Qty</MUITableCell>
              {showPointsColumn && (
                <MUITableCell
                  sx={{ width: "90px", textAlign: editMode ? "left" : "right" }}
                >
                  Points
                </MUITableCell>
              )}
              <MUITableCell sx={{ width: "60px" }}>Deliverable</MUITableCell>
              <MUITableCell sx={{ width: "60px" }}>Billable</MUITableCell>
              {showRentalColumn && (
                <MUITableCell sx={{ width: "60px" }}>Rental</MUITableCell>
              )}
              {showApprovedColumn && (
                <MUITableCell sx={{ width: "60px" }}>Approved</MUITableCell>
              )}
              {showAbnColumn && (
                <MUITableCell sx={{ width: "60px" }}>ABN</MUITableCell>
              )}
              {showDeliveredColumn && (
                <MUITableCell sx={{ width: "60px" }}>Delivered</MUITableCell>
              )}
              {showBrightreeColumn && (
                <MUITableCell sx={{ width: "200px" }}>Brightree</MUITableCell>
              )}
              {editMode && <MUITableCell sx={{ width: "50px" }}></MUITableCell>}
            </MUITableRow>
          </MUITableHead>
          <MUITableBody>
            {products.map((product, index) => {
              /*
               * Determine which icon to display based on the product type:
               * - Accessibility icon for types 33,3,15,2,10,1,30 (Wheelchair)
               * - Seat icon for type 25 (Cushion/Overlay)
               * - Power icon for type 32 (Accessories)
               * - Default widget icon for all other types
               */
              let icon = null;
              if ([33, 3, 15, 2, 10, 1, 30].includes(product?.productTypeId)) {
                icon = <MUIAccessibleIcon fontSize="small" />;
              } else if (product?.productTypeId === 25) {
                icon = <MUIEventSeatIcon fontSize="small" />;
              } else if (product?.productTypeId === 32) {
                icon = <MUIPowerIcon fontSize="small" />;
              } else {
                icon = <MUIWidgetIcon fontSize="small" />;
              }

              return (
                <React.Fragment key={index + "product"}>
                  <MUITableRow
                    sx={{
                      height: "52px",
                      ...(indexOfProductBeingUpgraded === index
                        ? { "& td": { borderBottom: "none" } }
                        : {}),
                    }}
                  >
                    <MUITableCell>
                      {parentProductIds.includes(product.id) ? null : (
                        <MUIChip
                          icon={icon}
                          size="small"
                          label={ProductType.getDisplayName(
                            mainContext.productTypesIndexed[
                              product.productTypeId
                            ],
                          )}
                          sx={{
                            height: "26px",
                            minWidth: "60px",
                            "& .MuiChip-label": {
                              px: 1.5,
                            },
                            backgroundColor: (theme) =>
                              theme.palette.background.default,
                          }}
                        />
                      )}
                    </MUITableCell>
                    <MUITableCell>
                      <MUIBox
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        {parentProductIds.includes(product.id) && (
                          <MUIUpgradeIcon fontSize="medium" />
                        )}
                        <MUIBox>
                          {(() => {
                            // If the product is received, use the original product's display name
                            const originalProduct =
                              chartContext.originalChart.product[product.id];
                            const serial = originalProduct?.serial;

                            return (
                              <>
                                {OrderActivity.getProductDisplayName(
                                  originalProduct || product,
                                  mainContext.baseUnitsIndexed,
                                  mainContext.vendorsIndexed,
                                  mainContext.productSubTypesIndexed,
                                )}
                                {serial && (
                                  <MUIBox
                                    sx={{
                                      fontSize: "0.875rem",
                                      color: "text.secondary",
                                    }}
                                  >
                                    {serial}
                                  </MUIBox>
                                )}
                              </>
                            );
                          })()}
                        </MUIBox>
                      </MUIBox>
                    </MUITableCell>
                    <MUITableCell>{product.hcpcs}</MUITableCell>
                    <MUITableCell>
                      {editMode ? (
                        <MUITextField
                          value={product.qty || 1}
                          type="number"
                          size="small"
                          variant="standard"
                          disabled={
                            orderActivity?.status === 3 || isOrderApproved
                          }
                          onChange={(e) => {
                            const qty = parseInt(e.target.value) || 1;
                            const productUpdate = {
                              qty: qty,
                            };

                            const amount = Product.getAmount(
                              product.hcpcs, //hcpcs code
                              product?.isRental, //isRental
                              mainContext.hcpcsCodesIndexed,
                              mainContext.feeSchedulesIndexed,
                            );

                            if (amount !== null) {
                              productUpdate.amount = amount;
                            }

                            const approvalUpdate =
                              getEquipmentPatientResponsibilityUpdate({
                                [product.id]: productUpdate,
                              });

                            chartContext.onChange({
                              ...(approvalUpdate || {}),
                              product: {
                                [product.id]: {
                                  ...productUpdate,
                                },
                              },
                            });
                            setCardChart({ ...cardChart, ...productUpdate });
                          }}
                        />
                      ) : (
                        product.qty
                      )}
                    </MUITableCell>
                    {showPointsColumn && (
                      <MUITableCell sx={{ textAlign: "right" }}>
                        {product.upgradedFromProductId ? null : editMode ? (
                          <MUITextField
                            value={product.points || 0}
                            type="number"
                            inputProps={{
                              step: "0.01",
                              min: "0",
                            }}
                            disabled={
                              !mainContext.currentUser.canEditPoints ||
                              isOrderApproved
                            }
                            size="small"
                            variant="standard"
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "" || !isNaN(value)) {
                                const points =
                                  value === ""
                                    ? ""
                                    : parseFloat(parseFloat(value).toFixed(2));
                                chartContext.onChange({
                                  product: {
                                    [product.id]: {
                                      points:
                                        points === "" ? 0 : parseFloat(points),
                                    },
                                  },
                                });
                                setCardChart({ ...cardChart, points: points });
                              }
                            }}
                          />
                        ) : product.points ? (
                          product.points.toFixed(2)
                        ) : (
                          ""
                        )}
                      </MUITableCell>
                    )}
                    <MUITableCell sx={{ textAlign: "center" }}>
                      {editMode ? (
                        <MUIFormControlLabel
                          sx={{
                            m: 0,
                            display: "flex",
                            justifyContent: "center",
                          }}
                          control={
                            <MUICheckbox
                              checked={product.deliverable || false}
                              disabled
                              size="small"
                            />
                          }
                        />
                      ) : product.deliverable ? (
                        <MUILocalShippingIcon
                          fontSize="small"
                          sx={{
                            color: (theme) =>
                              product.deliverable
                                ? theme.palette.primary.main
                                : theme.palette.text.disabled,
                          }}
                        />
                      ) : null}
                    </MUITableCell>
                    <MUITableCell sx={{ textAlign: "center" }}>
                      {editMode ? (
                        <MUIFormControlLabel
                          sx={{
                            m: 0,
                            display: "flex",
                            justifyContent: "center",
                          }}
                          control={
                            <MUICheckbox
                              checked={product.billable || false}
                              disabled={
                                orderActivity?.status === 3 || isOrderApproved
                              }
                              onChange={(e) => {
                                const productUpdate = {
                                  billable: e.target.checked,
                                };
                                const approvalUpdate =
                                  getEquipmentPatientResponsibilityUpdate({
                                    [product.id]: productUpdate,
                                  });

                                chartContext.onChange({
                                  ...(approvalUpdate || {}),
                                  product: {
                                    [product.id]: {
                                      ...productUpdate,
                                    },
                                  },
                                });
                                setCardChart({
                                  ...cardChart,
                                  billable: e.target.checked,
                                });
                              }}
                              size="small"
                            />
                          }
                        />
                      ) : product.billable ? (
                        <MUIRequestQuoteIcon
                          fontSize="small"
                          sx={{
                            color: (theme) =>
                              product.billable
                                ? theme.palette.success.light
                                : theme.palette.text.disabled,
                          }}
                        />
                      ) : null}
                    </MUITableCell>
                    {showRentalColumn && (
                      <MUITableCell sx={{ textAlign: "center" }}>
                        {editMode ? (
                          <MUIFormControlLabel
                            sx={{
                              m: 0,
                              display: "flex",
                              justifyContent: "center",
                            }}
                            control={
                              <MUICheckbox
                                checked={product.isRental || false}
                                onChange={(e) => {
                                  const isRental = e.target.checked;
                                  const productUpdate = {
                                    isRental: isRental,
                                  };

                                  const amount = Product.getAmount(
                                    product.hcpcs, //hcpcs code
                                    isRental, //isRental
                                    mainContext.hcpcsCodesIndexed,
                                    mainContext.feeSchedulesIndexed,
                                  );

                                  if (amount !== null) {
                                    productUpdate.amount = amount;
                                  }

                                  const approvalUpdate =
                                    getEquipmentPatientResponsibilityUpdate({
                                      [product.id]: productUpdate,
                                    });

                                  chartContext.onChange({
                                    ...(approvalUpdate || {}),
                                    product: {
                                      [product.id]: {
                                        ...productUpdate,
                                      },
                                    },
                                  });
                                  setCardChart({
                                    ...cardChart,
                                    ...productUpdate,
                                  });
                                }}
                                size="small"
                              />
                            }
                          />
                        ) : product.isRental ? (
                          <MUICheckIcon
                            fontSize="small"
                            sx={{
                              color: (theme) => theme.palette.success.main,
                            }}
                          />
                        ) : null}
                      </MUITableCell>
                    )}
                    {showApprovedColumn && (
                      <MUITableCell sx={{ textAlign: "center" }}>
                        {editMode ? (
                          <MUIFormControlLabel
                            sx={{
                              m: 0,
                              display: "flex",
                              justifyContent: "center",
                            }}
                            control={
                              <MUICheckbox
                                checked={product.approved}
                                disabled={
                                  isOrderApproved ||
                                  !allowApproving ||
                                  modifiedProducts.some(
                                    (modifiedProduct) =>
                                      modifiedProduct.upgradedFromProductId ===
                                      product.id,
                                  )
                                }
                                onChange={(e) => {
                                  const parentProduct =
                                    product.upgradedFromProductId
                                      ? modifiedProducts.find(
                                          (modifiedProduct) =>
                                            modifiedProduct.id ===
                                            product.upgradedFromProductId,
                                        )
                                      : null;
                                  const updates = {
                                    product: {
                                      [product.id]: {
                                        approved: e.target.checked,
                                      },
                                    },
                                  };
                                  if (parentProduct) {
                                    updates.product[parentProduct.id] = {
                                      approved: e.target.checked,
                                    };
                                  }
                                  chartContext.onChange(updates);
                                  setCardChart({
                                    ...cardChart,
                                    approved: e.target.checked,
                                  });
                                }}
                                size="small"
                              />
                            }
                          />
                        ) : product.approved ? (
                          <MUICheckIcon
                            fontSize="small"
                            sx={{
                              color: (theme) => theme.palette.success.main,
                            }}
                          />
                        ) : null}
                      </MUITableCell>
                    )}
                    {showAbnColumn && (
                      <MUITableCell sx={{ textAlign: "center" }}>
                        {editMode ? (
                          <MUIFormControlLabel
                            sx={{
                              m: 0,
                              display: "flex",
                              justifyContent: "center",
                            }}
                            control={
                              <MUICheckbox
                                checked={product.abnRequired || false}
                                disabled={!allowToggleAbn}
                                onChange={(e) => {
                                  chartContext.onChange({
                                    product: {
                                      [product.id]: {
                                        abnRequired: e.target.checked,
                                      },
                                    },
                                  });
                                  setCardChart({
                                    ...cardChart,
                                    abnRequired: e.target.checked,
                                  });
                                }}
                                size="small"
                              />
                            }
                          />
                        ) : product.abnRequired ? (
                          <MUICheckIcon
                            fontSize="small"
                            sx={{
                              color: (theme) => theme.palette.success.main,
                            }}
                          />
                        ) : null}
                      </MUITableCell>
                    )}
                    {showDeliveredColumn && (
                      <MUITableCell sx={{ textAlign: "center" }}>
                        {isProductDelivered(product) ? (
                          <MUICheckIcon
                            fontSize="small"
                            sx={{
                              color: (theme) => theme.palette.success.main,
                            }}
                          />
                        ) : null}
                      </MUITableCell>
                    )}
                    {showBrightreeColumn && (
                      <MUITableCell>
                        {editMode ? (
                          <MUIAutocomplete
                            options={btProductsFound[product.id] || []}
                            value={
                              (btProductsFound[product.id] || []).find(
                                (option) => option?.itemId === product.btitemId,
                              ) || null
                            }
                            isOptionEqualToValue={(option, value) =>
                              option?.itemId === value?.itemId
                            }
                            getOptionLabel={(option) =>
                              BtProduct.getDisplayName(option) || ""
                            }
                            onChange={(e, newValue) => {
                              chartContext.onChange({
                                product: {
                                  [product.id]: {
                                    btitemId: newValue?.itemId || null,
                                  },
                                },
                              });
                              setCardChart({
                                ...cardChart,
                                btitemId: newValue?.itemId || null,
                              });
                            }}
                            onInputChange={(e, newInputValue, reason) => {
                              if (reason === "input") {
                                chartContext.onChange({
                                  product: {
                                    [product.id]: {
                                      btitemId: null,
                                    },
                                  },
                                });
                                setCardChart({ ...cardChart, btitemId: null });
                                throttledHandleBtProductSearch(
                                  newInputValue,
                                  product,
                                );
                              }
                            }}
                            onOpen={() => {
                              throttledHandleBtProductSearch("", product);
                            }}
                            onFocus={() => {
                              throttledHandleBtProductSearch("", product);
                            }}
                            noOptionsText="No items found"
                            renderInput={(params) => (
                              <MUITextField
                                {...params}
                                InputLabelProps={{ shrink: true }}
                                size="small"
                                variant="standard"
                                fullWidth
                              />
                            )}
                          />
                        ) : (
                          product.btitemId || ""
                        )}
                      </MUITableCell>
                    )}
                    {editMode && !parentProductIds.includes(product.id)
                      ? renderRowActions(product, index)
                      : null}
                  </MUITableRow>
                  {productUpgradeOpen &&
                  indexOfProductBeingUpgraded === index ? (
                    <MUITableRow>
                      <MUITableCell
                        colSpan={12}
                        sx={{ borderBottom: "none", padding: 0 }}
                      >
                        <MUICollapse in={productUpgradeOpen}>
                          <MUITable>
                            <MUITableBody>
                              {renderProductUpgradeRow(product, index)}
                            </MUITableBody>
                          </MUITable>
                        </MUICollapse>
                      </MUITableCell>
                    </MUITableRow>
                  ) : null}
                  {receiveProductOpen &&
                  indexOfProductBeingReceived === index ? (
                    <MUITableRow>
                      <MUITableCell
                        colSpan={12}
                        sx={{ borderBottom: "none", padding: 0 }}
                      >
                        <MUICollapse in={receiveProductOpen}>
                          <MUITable>
                            <MUITableBody>
                              {renderReceiveProductRow(product, index)}
                            </MUITableBody>
                          </MUITable>
                        </MUICollapse>
                      </MUITableCell>
                    </MUITableRow>
                  ) : null}
                </React.Fragment>
              );
            })}
          </MUITableBody>
        </MUITable>
        {showPointsDoNotMatchAlert && (
          <MUIAlert severity="warning" sx={{ mt: 1 }}>
            One or more products have points that don't match the expected
            values. This can happen if the points were manually changed or if
            something like insurance information was updated.
          </MUIAlert>
        )}
      </MUITableContainer>
    );
  };

  // Format ABN amount for input display (commas, two decimals)
  const formatAbnAmount = (value) => {
    if (value === "" || value === null || isNaN(Number(value))) return "";
    const numValue = Number(value);
    return numValue.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Set formatted initial value for abnAmountInput
  useEffect(() => {
    setAbnAmountInput(formatAbnAmount(orderActivity.abnAmount));
  }, [orderActivity.abnAmount]);

  /**
   * Renders the ABN fields.
   * @returns {JSX.Element}
   */
  const renderABNFields = () => {
    // Find approval for this order
    const orderActivityApprovals = Object.values(
      chartContext.chart.orderActivityApprovals || {},
    ).find(
      (orderActivityApproval) =>
        orderActivityApproval.orderActivityId === chartContext.orderId,
    );
    const approvalId = orderActivityApprovals?.approvalsId;
    const approval = approvalId
      ? chartContext.chart.approval?.[approvalId]
      : null;
    const abnRequiredNote = approval?.abnRequiredNote ?? "";

    // Format as USD for view mode
    const abnAmountFormatted = orderActivity.abnAmount
      ? new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(Number(orderActivity.abnAmount))
      : "";

    // Handles changes to the abnAmount input field (free typing, only numbers and periods)
    const handleAbnAmountInputChange = (value) => {
      if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
        setAbnAmountInput(value);
      }
    };

    // Handles blur event for abnAmount input (parse and update context)
    const handleAbnAmountInputBlur = (value) => {
      const trimmed = value.trim();
      const cleaned = trimmed.replace(/,/g, ""); // remove commas
      const numValue = parseFloat(cleaned);

      chartContext.onChange({
        orderActivity: {
          [chartContext.orderId]: {
            abnAmount: cleaned === "" || isNaN(numValue) ? null : numValue,
          },
        },
      });

      setAbnAmountInput(formatAbnAmount(numValue));
      setCardChart({ ...cardChart, abnAmount: cleaned });
    };

    if (editMode) {
      return (
        <MUIGrid container spacing={2} sx={{ mt: 2, mb: 2 }}>
          <MUIGrid item xs={12} md={3}>
            <MUITextField
              label="ABN Amount"
              variant="standard"
              size="small"
              fullWidth
              value={abnAmountInput}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                maxLength: 255,
                style: { textAlign: "right" },
                inputMode: "decimal",
                pattern: "[0-9.]*",
              }}
              InputProps={{
                startAdornment: (
                  <MUIInputAdornment position="start">$</MUIInputAdornment>
                ),
              }}
              disabled={!hasAbnRequired}
              onBlur={(e) => handleAbnAmountInputBlur(e.target.value)}
              onChange={(e) => handleAbnAmountInputChange(e.target.value)}
              required={hasAbnRequired}
              error={
                chartContext.validationIssues[className]?.orderActivity?.[
                  orderActivity.id
                ]?.abnAmount
                  ? true
                  : false
              }
              helperText={
                chartContext.validationIssues[className]?.orderActivity?.[
                  orderActivity.id
                ]?.abnAmount
                  ? chartContext.validationIssues[className]?.orderActivity?.[
                      orderActivity.id
                    ]?.abnAmount
                  : ""
              }
            />
          </MUIGrid>
          <MUIGrid item xs={12} md={9}>
            <MUITextField
              label="ABN Reason"
              variant="standard"
              size="small"
              fullWidth
              value={abnRequiredNote}
              InputLabelProps={{ shrink: true }}
              disabled={!hasAbnRequired}
              onBlur={(e) => {
                const value = e.target.value.trim();
                if (approvalId) {
                  chartContext.onChange({
                    approval: {
                      [approvalId]: {
                        abnRequiredNote: value,
                      },
                    },
                  });
                  setCardChart({ ...cardChart, abnRequiredNote: value });
                }
              }}
              onChange={(e) => {
                const value = e.target.value;
                if (approvalId) {
                  chartContext.onChange({
                    approval: {
                      [approvalId]: {
                        abnRequiredNote: value,
                      },
                    },
                  });
                  setCardChart({ ...cardChart, abnRequiredNote: value });
                }
              }}
              required={hasAbnRequired}
              error={
                chartContext.validationIssues[className]?.approval?.[approvalId]
                  ?.abnRequiredNote
                  ? true
                  : false
              }
              helperText={
                chartContext.validationIssues[className]?.approval?.[approvalId]
                  ?.abnRequiredNote
                  ? chartContext.validationIssues[className]?.approval?.[
                      approvalId
                    ]?.abnRequiredNote
                  : ""
              }
            />
          </MUIGrid>
        </MUIGrid>
      );
    }

    // View mode: only show if at least one product has abnRequired
    if (!hasAbnRequired) {
      return null;
    }

    return (
      <MUIGrid container spacing={2} sx={{ mt: 2, mb: 2 }}>
        <MUIGrid item xs={12} md={3}>
          <InfoItem label="ABN Amount" value={abnAmountFormatted} />
        </MUIGrid>
        <MUIGrid item xs={12} md={9}>
          <InfoItem label="ABN Reason" value={abnRequiredNote} />
        </MUIGrid>
      </MUIGrid>
    );
  };

  /**
   * Renders the actions for a product row.
   * @param {Object} product - The product object
   * @param {number} index - The index of the product
   * @returns {JSX.Element} MUITableCell component for product row actions
   */
  const renderRowActions = (product, index) => {
    const handleCancelUpgrade = (product) => {
      const orderActivityProducts =
        chartContext.chart.orderActivityProducts || {};
      const products = chartContext.chart.product || {};
      const originalProduct = sortedOrderProducts.find(
        (originalProduct) => originalProduct.id === product.id,
      );

      // Find and remove the upgrade product
      const upgradedProductId = product.upgradedFromProductId;
      const filteredOrderActivityProducts = { ...orderActivityProducts };
      const filteredProducts = { ...products };

      // Remove from both objects
      delete filteredOrderActivityProducts[upgradedProductId];
      delete filteredProducts[upgradedProductId];

      // Reset the upgradedFromProductId on the original product
      filteredProducts[product.id] = {
        ...originalProduct,
        qty: product.qty,
      };

      const approvalUpdate = getEquipmentPatientResponsibilityUpdate({
        [upgradedProductId]: { deleted: true },
        [product.id]: filteredProducts[product.id],
      });

      // Update context with filtered products
      chartContext.onChange({
        ...(approvalUpdate || {}),
        orderActivityProducts: filteredOrderActivityProducts,
        product: filteredProducts,
      });

      setProductUpgradeOpen(false);
      setIndexOfProductBeingUpgraded(null);
      setShowUpgradeToAnything(false);
    };

    const handleCancelReceiveProduct = (product) => {
      const products = chartContext.chart.product || {};
      const originalProduct = sortedOrderProducts.find(
        (originalProduct) => originalProduct.id === product.id,
      );

      const receiveProductId = product.id;
      const filteredProducts = { ...products };

      // Reset the receive product on the original product
      filteredProducts[receiveProductId] = {
        ...originalProduct,
      };

      // Update context with filtered products
      chartContext.onChange({
        product: filteredProducts,
      });

      const productFields = cardChart ? Object.keys(cardChart) : [];

      const clearedIssues = { ...chartContext.validationIssues };
      productFields.forEach((field) => {
        delete clearedIssues[className]?.product?.[product.id]?.[field];
      });
      chartContext.updateValidationIssues(clearedIssues);

      setSelectedReceiveProductVendor(null);
      setReceiveProductOpen(false);
      setIndexOfProductBeingReceived(null);
      setProductBeingReceived(null);
    };

    const handleRemoveUpgrade = (product) => {
      const upgradedFromProduct = sortedOrderProducts.find(
        (p) => p.id === product.upgradedFromProductId,
      );
      const updatedProduct = {
        ...product,
        billable: true,
        points: Product.getPoints(
          mainContext.productSubTypesIndexed[product.productSubTypeId],
          orderActivity.insuranceTypeId,
          mainContext.insuranceMatrixEntriesIndexed,
          mainContext.productMatrixEntriesIndexed,
          product,
        ),
        upgradedFromProductId: null,
      };
      const removedProduct = {
        ...upgradedFromProduct,
        deleted: true,
      };
      const updates = {
        product: {
          [upgradedFromProduct.id]: removedProduct,
          [product.id]: updatedProduct,
        },
      };
      const approvalUpdate = getEquipmentPatientResponsibilityUpdate({
        [upgradedFromProduct.id]: removedProduct,
        [product.id]: updatedProduct,
      });
      if (approvalUpdate) {
        Object.assign(updates, approvalUpdate);
      }
      chartContext.onChange(updates);
      setCardChart({
        ...cardChart,
        deleted: true,
        upgradedFromProductId: null,
        billable: true,
        points: Product.getPoints(
          mainContext.productSubTypesIndexed[product.productSubTypeId],
          orderActivity.insuranceTypeId,
          mainContext.insuranceMatrixEntriesIndexed,
          mainContext.productMatrixEntriesIndexed,
          product,
        ),
      });
    };

    return (
      <MUITableCell align="right">
        {(productUpgradeOpen && indexOfProductBeingUpgraded === index) ||
        (receiveProductOpen && indexOfProductBeingReceived === index) ? (
          <MUIButton
            size="small"
            onClick={() => {
              if (productUpgradeOpen && indexOfProductBeingUpgraded === index) {
                handleCancelUpgrade(product);
              } else if (
                receiveProductOpen &&
                indexOfProductBeingReceived === index
              ) {
                handleCancelReceiveProduct(product);
              }
            }}
            color="error"
          >
            Cancel
          </MUIButton>
        ) : (
          <Menu
            menuItems={(() => {
              const menuItems = [];

              if (editableProductTypeIds.includes(product.productTypeId)) {
                if (product?.upgradedFromProductId === null) {
                  menuItems.push(
                    <MUIMenuItem
                      disabled={
                        orderActivity?.status === 3 ||
                        isOrderApproved ||
                        productUpgradeOpen ||
                        product?.id < 0
                      }
                      onClick={() => {
                        setShowUpgradeToAnything(false);
                        setProductUpgradeOpen(true);
                        setIndexOfProductBeingUpgraded(index);
                      }}
                    >
                      <MUIListItemIcon>
                        <MUIUpgradeIcon fontSize="small" />
                      </MUIListItemIcon>
                      Upgrade
                    </MUIMenuItem>,
                  );
                } else {
                  menuItems.push(
                    <MUIMenuItem
                      disabled={orderActivity?.status === 3 || isOrderApproved}
                      onClick={() => {
                        handleRemoveUpgrade(product);
                      }}
                    >
                      <MUIListItemIcon>
                        <MUIBackspaceIcon fontSize="small" />
                      </MUIListItemIcon>
                      Remove Upgrade
                    </MUIMenuItem>,
                  );
                }
              }
              menuItems.push(
                <MUIMenuItem
                  disabled={product?.id < 0}
                  onClick={() => {
                    setReceiveProductOpen(true);
                    setProductBeingReceived(product);
                    setIndexOfProductBeingReceived(index);
                  }}
                >
                  <MUIListItemIcon>
                    <MUIInventoryIcon fontSize="small" />
                  </MUIListItemIcon>
                  Receive Product
                </MUIMenuItem>,
                <MUIMenuItem
                  disabled={orderActivity?.status === 3 || isOrderApproved}
                  onClick={() => {
                    if (modifiedProducts.length === 1) {
                      NotistackEnqueueSnackbar(
                        "Cannot delete if there is only one product",
                        { variant: "error" },
                      );
                      return;
                    }

                    // If the product is a negative id, remove it entirely
                    if (product.id < 0) {
                      const updates = {
                        product: {
                          [product.id]: undefined,
                        },
                        orderActivityProducts: {
                          [product.id]: undefined,
                        },
                      };
                      const approvalUpdate =
                        getEquipmentPatientResponsibilityUpdate({
                          [product.id]: { deleted: true },
                        });
                      if (approvalUpdate) {
                        Object.assign(updates, approvalUpdate);
                      }
                      chartContext.onChange(updates);
                      return;
                    }
                    if (
                      product.upgradedFromProductId &&
                      product.upgradedFromProductId !== null
                    ) {
                      const upgradedFromProduct = sortedOrderProducts.find(
                        (p) => p.id === product.upgradedFromProductId,
                      );

                      const updates = {
                        product: {
                          [product.id]: {
                            deleted: true,
                          },
                          [upgradedFromProduct.id]: {
                            deleted: true,
                          },
                        },
                      };
                      const approvalUpdate =
                        getEquipmentPatientResponsibilityUpdate({
                          [product.id]: { deleted: true },
                          [upgradedFromProduct.id]: { deleted: true },
                        });
                      if (approvalUpdate) {
                        Object.assign(updates, approvalUpdate);
                      }
                      chartContext.onChange(updates);
                    } else {
                      const updates = {
                        product: {
                          [product.id]: {
                            deleted: true,
                          },
                        },
                      };
                      const approvalUpdate =
                        getEquipmentPatientResponsibilityUpdate({
                          [product.id]: { deleted: true },
                        });
                      if (approvalUpdate) {
                        Object.assign(updates, approvalUpdate);
                      }
                      chartContext.onChange(updates);
                    }
                    setCardChart({ ...cardChart, deleted: true });
                  }}
                >
                  <MUIListItemIcon>
                    <MUIDeleteIcon fontSize="small" />
                  </MUIListItemIcon>
                  Delete
                </MUIMenuItem>,
              );
              return menuItems;
            })()}
          />
        )}
      </MUITableCell>
    );
  };

  /**
   * Renders a row for upgrading a product.
   * @param {Object} product - The product object
   * @param {number} index - The index of the product
   * @returns {JSX.Element} MUITableRow component for product upgrade row
   */
  const renderProductUpgradeRow = (product, index) => {
    const getProductSubTypeDisplayName = (
      productSubType,
      includeProductType = false,
    ) => {
      const productType =
        mainContext.productTypesIndexed?.[productSubType?.productTypeId];
      const productSubTypeName = productSubType?.name || "";
      const productSubTypeHcpcs = productSubType?.hcpcs || "";

      if (includeProductType === true) {
        const productTypeName = ProductType.getDisplayName(productType);
        return `${productTypeName} - ${productSubTypeName} (${productSubTypeHcpcs})`;
      }

      return `${productSubTypeName} (${productSubTypeHcpcs})`;
    };

    const getSortedProductSubTypes = () => {
      const productSubTypes = Object.values(
        mainContext.productSubTypesIndexed || {},
      );

      if (
        Security.hasPermission("order.upgradeToAnything") &&
        showUpgradeToAnything
      ) {
        const sortedProductTypes = ProductType.sort(
          Object.values(mainContext.productTypesIndexed || {}).filter(
            (productType) => editableProductTypeIds.includes(productType.id),
          ),
        );
        const groupedProductSubTypes = sortedProductTypes.flatMap(
          (productType) => {
            const subTypesForType = productSubTypes.filter(
              (productSubType) =>
                productSubType.productTypeId === productType.id,
            );
            return ProductSubType.sort(subTypesForType);
          },
        );

        return groupedProductSubTypes;
      }

      return ProductSubType.sort(
        productSubTypes.filter(
          (productSubType) =>
            productSubType.productTypeId === product?.productTypeId,
        ),
      );
    };

    const getProductSubTypeOptions = () => {
      return getSortedProductSubTypes().map((option) => {
        return {
          title: getProductSubTypeDisplayName(
            option,
            Security.hasPermission("order.upgradeToAnything") &&
              showUpgradeToAnything,
          ),
          value: option.id,
          key: option.id,
        };
      });
    };

    /**
     * Handles the addition of a selected upgrade.
     * @param {Object} selectedUpgrade - The selected upgrade object
     */
    const handleAddSelectedUpgrade = (selectedUpgrade) => {
      if (selectedUpgrade) {
        const existingProducts = chartContext.chart.product || {};
        const newProductId = -1 * (Object.keys(existingProducts).length + 1);

        // Filter out any previous upgrade products (only take the latest selected from the dropdown)
        const filteredProducts = Object.fromEntries(
          Object.entries(existingProducts).filter(
            ([_, prod]) => !prod.selectedUpgrade,
          ),
        );

        const selectedUpgradeSubType =
          mainContext.productSubTypesIndexed[selectedUpgrade.value];
        const selectedUpgradeDefaultQty =
          selectedUpgradeSubType?.defaultQuantity > 0
            ? selectedUpgradeSubType.defaultQuantity
            : 1;

        const products = {
          ...filteredProducts,
          [product.id]: {
            ...product,
            billable: false,
            deliverable: true,
            points: 0,
            abnRequired: false,
            btitemId: null,
            upgradedFromProductId: newProductId,
          },
          [newProductId]: {
            id: newProductId,
            abnRequired: false,
            approved: false,
            hcpcs: selectedUpgradeSubType?.hcpcs || "",
            productSubTypeId: selectedUpgrade.value,
            productTypeId: selectedUpgradeSubType?.productTypeId,
            deliverable: false,
            billable: true,
            qty: selectedUpgradeDefaultQty,
            points: Product.getPoints(
              selectedUpgradeSubType,
              orderActivity.insuranceTypeId,
              mainContext.insuranceMatrixEntriesIndexed,
              mainContext.productMatrixEntriesIndexed,
            ),
            serial: "",
            amount: null,
            isRental: false,
            selectedUpgrade: true,
          },
        };

        products[newProductId].amount =
          Product.getAmount(
            products[newProductId].hcpcs, //hcpcs code
            products[newProductId]?.isRental, //isRental
            mainContext.hcpcsCodesIndexed,
            mainContext.feeSchedulesIndexed,
          ) ?? null;

        // Filter out any previous upgrade order activity products
        const filteredOrderProducts = Object.fromEntries(
          Object.entries(chartContext.chart.orderActivityProducts || {}).filter(
            ([_, prod]) => !existingProducts[prod.productsId]?.selectedUpgrade,
          ),
        );

        const orderActivityProducts = {
          ...filteredOrderProducts,
          [newProductId]: {
            orderActivityId: chartContext.orderId,
            productsId: newProductId,
          },
        };

        const approvalUpdate = getEquipmentPatientResponsibilityUpdate({
          [product.id]: products[product.id],
          [newProductId]: products[newProductId],
        });

        chartContext.onChange({
          ...(approvalUpdate || {}),
          product: products,
          orderActivityProducts: orderActivityProducts,
        });

        setCardChart({
          ...cardChart,
          upgradedFromProductId: newProductId,
          selectedUpgrade: true,
          billable: false,
          deliverable: true,
          points: 0,
        });
      }
    };

    if (
      editMode &&
      productUpgradeOpen &&
      editableProductTypeIds.includes(product.productTypeId)
    ) {
      return (
        <MUITableRow key={index + "upgrade"}>
          <MUITableCell colSpan={7}>
            <MUIBox
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 1,
              }}
            >
              <MUIStack direction="row" spacing={1} alignItems="flex-start">
                <MUIBox
                  sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}
                >
                  <MUIAutocomplete
                    sx={{ width: "480px" }}
                    options={getProductSubTypeOptions()}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    getOptionLabel={(option) =>
                      getProductSubTypeDisplayName(
                        mainContext.productSubTypesIndexed?.[option?.value],
                        Security.hasPermission("order.upgradeToAnything") &&
                          showUpgradeToAnything,
                      )
                    }
                    getOptionKey={(option) => option.key}
                    onChange={(e, newValue) =>
                      handleAddSelectedUpgrade(newValue)
                    }
                    disableClearable
                    renderInput={(params) => (
                      <MUITextField
                        {...params}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        size="small"
                        variant="standard"
                        label="Upgraded From"
                        fullWidth
                      />
                    )}
                  />
                  {Security.hasPermission("order.upgradeToAnything") && (
                    <MUITooltip
                      title={
                        showUpgradeToAnything
                          ? "Restore filtering"
                          : "Expand to all equipment"
                      }
                      placement="top"
                    >
                      <MUIIconButton
                        size="small"
                        color={showUpgradeToAnything ? "primary" : "default"}
                        aria-label={
                          showUpgradeToAnything
                            ? "Restore filtering"
                            : "Expand to all equipment"
                        }
                        onClick={() =>
                          setShowUpgradeToAnything(
                            (previousValue) => !previousValue,
                          )
                        }
                        sx={{
                          mt: 0.5,
                        }}
                      >
                        {showUpgradeToAnything ? (
                          <MUIFilterAltIcon fontSize="small" />
                        ) : (
                          <MUIFilterAltOffIcon fontSize="small" />
                        )}
                      </MUIIconButton>
                    </MUITooltip>
                  )}
                </MUIBox>
              </MUIStack>
              {showUpgradeToAnything && (
                <MUIAlert severity="warning" sx={{ width: "100%" }}>
                  Filtering is disabled. Be cautious when selecting upgrades.
                </MUIAlert>
              )}
            </MUIBox>
          </MUITableCell>
        </MUITableRow>
      );
    }
    return null;
  };

  const renderReceiveProductRow = (product, index) => {
    const getVendorOptions = () => {
      return Vendor.sort(Object.values(mainContext.vendorsIndexed))
        .filter((vendor) => {
          return Object.values(mainContext.baseUnitsIndexed).some(
            (baseUnit) => baseUnit.vendorId === vendor.id,
          );
        })
        .map((vendor) => {
          return {
            label: vendor.name,
            value: vendor.id,
            key: vendor.id,
          };
        });
    };

    const getBaseUnitOptions = () => {
      return BaseUnit.sort(Object.values(mainContext.baseUnitsIndexed))
        .filter((baseUnit) => {
          if (!selectedReceiveProductVendor) {
            return true;
          }
          return baseUnit.vendorId === selectedReceiveProductVendor?.value;
        })
        .map((baseUnit) => {
          return {
            label: baseUnit.name,
            value: baseUnit.id,
            key: baseUnit.id,
            vendorId: baseUnit.vendorId,
          };
        });
    };

    const productType = mainContext.productTypesIndexed[product.productTypeId];

    if (
      editMode &&
      receiveProductOpen &&
      indexOfProductBeingReceived === index
    ) {
      return (
        <MUITableRow key={index + "receive"}>
          <MUITableCell colSpan={7}>
            <MUIBox
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 2,
              }}
            >
              <MUIGrid container spacing={2}>
                {productType?.requiresSerialNumber && (
                  <>
                    <MUIGrid item xs={12} md={6} lg={3}>
                      <MUIAutocomplete
                        options={getVendorOptions()}
                        isOptionEqualToValue={(option, value) =>
                          option.value === value.value
                        }
                        getOptionLabel={(option) => option.label}
                        getOptionKey={(option) => option.key}
                        disableClearable
                        value={
                          getVendorOptions().find(
                            (option) =>
                              option.value ===
                              mainContext.baseUnitsIndexed[product.baseUnitId]
                                ?.vendorId,
                          ) || selectedReceiveProductVendor
                        }
                        onChange={(e, newValue) => {
                          setSelectedReceiveProductVendor(newValue);
                          chartContext.onChange({
                            product: { [product.id]: { baseUnitId: null } },
                          });
                          setCardChart({ ...cardChart, baseUnitId: null });
                        }}
                        renderInput={(params) => (
                          <MUITextField
                            {...params}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            size="small"
                            variant="standard"
                            label="Vendor"
                            fullWidth
                          />
                        )}
                      />
                    </MUIGrid>
                    <MUIGrid item xs={12} md={6} lg={3}>
                      <MUIAutocomplete
                        options={getBaseUnitOptions()}
                        isOptionEqualToValue={(option, value) =>
                          option.value === value.value
                        }
                        getOptionLabel={(option) => option.label}
                        getOptionKey={(option) => option.key}
                        value={
                          getBaseUnitOptions().find(
                            (option) => option.value === product.baseUnitId,
                          ) || null
                        }
                        onChange={(e, newValue) => {
                          chartContext.onChange({
                            product: {
                              [product.id]: {
                                baseUnitId: newValue?.value || null,
                              },
                            },
                          });
                          setCardChart({
                            ...cardChart,
                            baseUnitId: newValue?.value || null,
                          });
                        }}
                        renderInput={(params) => (
                          <MUITextField
                            {...params}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            size="small"
                            variant="standard"
                            label="Base Unit"
                            fullWidth
                            required={true}
                            error={
                              chartContext.validationIssues[className]
                                ?.product?.[product.id]?.baseUnitId
                                ? true
                                : false
                            }
                            helperText={
                              chartContext.validationIssues[className]
                                ?.product?.[product.id]?.baseUnitId
                                ? chartContext.validationIssues[className]
                                    ?.product?.[product.id]?.baseUnitId
                                : ""
                            }
                          />
                        )}
                      />
                    </MUIGrid>
                  </>
                )}
                <MUIGrid item xs={12} md={6} lg={3}>
                  <MUITextField
                    value={product.serial ? product.serial : ""}
                    size="small"
                    label="Serial Number"
                    variant="standard"
                    fullWidth={true}
                    inputProps={{
                      maxLength: 255,
                    }}
                    InputLabelProps={{ shrink: true }}
                    required={true}
                    onChange={(e) => {
                      chartContext.onChange({
                        product: {
                          [product.id]: { serial: e.target.value.trim() || "" },
                        },
                      });
                      setCardChart({
                        ...cardChart,
                        serial: e.target.value.trim() || "",
                      });
                    }}
                    error={
                      chartContext.validationIssues[className]?.product?.[
                        product.id
                      ]?.serial
                        ? true
                        : false
                    }
                    helperText={
                      chartContext.validationIssues[className]?.product?.[
                        product.id
                      ]?.serial
                        ? chartContext.validationIssues[className]?.product?.[
                            product.id
                          ]?.serial
                        : ""
                    }
                  />
                </MUIGrid>
              </MUIGrid>
            </MUIBox>
          </MUITableCell>
        </MUITableRow>
      );
    }
    return null;
  };

  useEffect(() => {
    if (!shouldSave) {
      return;
    }
    chartContext.handleSaveChart(null, async () => {
      setAddingOrderProducts(false);
      setUploadQuoteDialogOpen(false);
      setEditMode(false);
      setShouldSave(false);
      setOriginalUploadQuoteFileId(null);
    });
  }, [shouldSave]);

  /**
   * Renders a section for displaying uploaded files.
   * @returns {JSX.Element} MUIGrid component for uploaded files
   */
  const renderQuoteSection = () => {
    const handlePdfViewer = (uploadedFile) => {
      if (!Security.hasPermission("file.download")) {
        Setting.set("jspdf.file.download", false);
      } else {
        Setting.set("jspdf.file.download", true);
      }
      let sanitizedFileName = File.sanitizeUrlFilename(uploadedFile.filename);
      window.open(`/file/${uploadedFile.id}/${sanitizedFileName}`, "_blank");
    };

    /**
     * Handles the reprocessing of a quote.
     * @param {string} quoteFileId - The ID of the quote file to reprocess.
     * @returns {Promise} A promise that resolves to the reprocessed quote data.
     */
    const handleReprocessQuote = async (quoteFileId) => {
      if (!originalUploadQuoteFileId && !quoteFileId) {
        NotistackEnqueueSnackbar("Issue reprocessing quote", {
          variant: "error",
        });
        return;
      }

      const uploadedFileId = quoteFileId
        ? quoteFileId
        : originalUploadQuoteFileId;

      setUploadingQuote(true);
      setUploadQuoteDialogOpen(true);
      setOriginalUploadQuoteFileId(uploadedFileId);

      return await api
        .send("POST", "/aiQuoteParser/sendToAiQuoteParser", {
          UploadedFileId: uploadedFileId,
        })
        .then((res) => {
          setUploadQuoteData(res);
          setUploadingQuote(false);
        })
        .catch((e) => {
          NotistackEnqueueSnackbar("Reprocess failed.", {
            variant: "error",
          });
          setUploadingQuote(false);
        });
    };

    /**
     * Creates a purchase queue entry from a quote attachment.
     * Adds a new purchaseQueue row to the chart using a negative ID.
     * @param {Object} uploadedFile - The quote file to order from.
     */
    const createPurchaseQueueFromQuote = (uploadedFile) => {
      const currentUser = mainContext.currentUser;
      const negativePurchaseQueueId = chartContext.getNegativeId();
      const activityFile = UploadedFile.getActivityFile(
        uploadedFile,
        chartContext.chart,
      );

      chartContext.onChange({
        purchaseQueue: {
          [negativePurchaseQueueId]: {
            id: negativePurchaseQueueId,
            orderId: chartContext.orderId,
            quoteId: uploadedFile.id,
            vendorId: activityFile?.vendorId ?? null,
            quantity: 1,
            requestedOn: new Date().toISOString(),
            requestedById: currentUser.id,
            status: "PENDING",
            statusChangedOn: new Date().toISOString(),
            statusChangedById: currentUser.id,
          },
        },
      });
    };

    /**
     * Builds the display label for the "Order from quote" menu option.
     *
     * If the quote has not been ordered, a simple label is shown.
     * If purchase_queue rows already exist, the label includes the
     * most recent status and date to provide user context.
     *
     * @param {Object} uploadedFile - The uploaded file object representing the quote.
     * @returns {string} The menu label to display.
     */
    const getOrderFromQuoteMenuLabel = (uploadedFile) => {
      const purchaseQueues = getPurchaseQueuesForQuoteFile(uploadedFile.id);

      if (!purchaseQueues.length) {
        return "Order from quote";
      }

      const mostRecentPurchaseQueue = purchaseQueues.sort(
        (firstQueue, secondQueue) =>
          new Date(secondQueue.statusChangedOn) -
          new Date(firstQueue.statusChangedOn),
      )[0];

      if (!mostRecentPurchaseQueue.status) {
        return "Order from quote (Status Unknown)";
      }

      const formattedStatus =
        mostRecentPurchaseQueue.status.charAt(0).toUpperCase() +
        mostRecentPurchaseQueue.status.slice(1).toLowerCase();

      if (mostRecentPurchaseQueue.statusChangedOn) {
        const formattedDate = new Date(
          mostRecentPurchaseQueue.statusChangedOn,
        ).toLocaleDateString();

        return `Order from quote (${formattedStatus} on ${formattedDate})`;
      }

      return `Order from quote (${formattedStatus})`;
    };

    /**
     * Handles the attachment icon buttons.
     * @param {Object} uploadedFile - The uploaded file to handle.
     * @returns {Array} An array of buttons.
     */
    const attachmentIconButtons = (uploadedFile) => {
      const activityFile = UploadedFile.getActivityFile(
        uploadedFile,
        chartContext.chart,
      );
      const isQuote = activityFile?.activityFileTypeTermId === 151; // 151 = Quote

      const menuItems = [];

      // Reprocess
      if (orderActivity?.orderType === "New") {
        menuItems.push(
          <MUIMenuItem
            onClick={() => {
              chartContext.handleSaveChart(async () => {
                handleReprocessQuote(uploadedFile.id);
              });
            }}
            disabled={
              !uploadedFile.contentType.includes("pdf") ||
              orderActivity?.isApproved
            }
          >
            <MUIListItemIcon>
              <MUIAutoAwesomeIcon />
            </MUIListItemIcon>
            Reprocess
          </MUIMenuItem>,
        );
      }

      // Order from quote (quote-only)
      if (isQuote && orderActivity?.orderType === "New") {
        const purchaseQueuesForQuote = getPurchaseQueuesForQuoteFile(
          uploadedFile.id,
        );
        const hasExistingOrder = purchaseQueuesForQuote.length > 0;

        menuItems.push(
          <MUIMenuItem
            key={`order-from-quote-${uploadedFile.id}`}
            disabled={hasExistingOrder}
            onClick={() => {
              createPurchaseQueueFromQuote(uploadedFile);
              setShouldSave(true);
            }}
          >
            <MUIListItemIcon>
              <MUIRequestQuoteIcon />
            </MUIListItemIcon>
            {getOrderFromQuoteMenuLabel(uploadedFile)}
          </MUIMenuItem>,
        );
      }

      return [<Menu menuItems={menuItems} />];
    };

    /**
     * Handles the application of products to the order.
     * @param {Array} products - The products to apply to the order.
     * @param {boolean} overwriteExisting - Whether to overwrite existing
     * products for this order.
     * @returns {Promise} A promise that resolves when the products are
     * applied.
     */
    const handleApplyProducts = async (products, overwriteExisting) => {
      setAddingOrderProducts(true);

      const productsWithProductSubType = products.filter(
        (product) =>
          product?.productSubType &&
          Object.keys(product.productSubType).length > 0,
      );

      if (!productsWithProductSubType.length) {
        setAddingOrderProducts(false);
        return;
      }

      // Build the products and orderActivityProducts objects
      const productsObject = {};
      const orderActivityProductsObject = {};

      // Remove all products for the current order if overwriteExisting is
      // true
      if (overwriteExisting) {
        Object.values(chartContext.chart.orderActivityProducts)
          .filter(
            (orderActivityProduct) =>
              orderActivityProduct.orderActivityId === chartContext.orderId,
          )
          .forEach((orderActivityProduct) => {
            productsObject[orderActivityProduct.productsId] = { deleted: true };
          });
      }

      // Loop through the products and build the products and
      // orderActivityProducts objects
      productsWithProductSubType.forEach((product) => {
        let negativeId = chartContext.getNegativeId();
        const quantity = product.qty || 1;
        productsObject[negativeId] = {
          id: negativeId,
          abnRequired: false,
          approved: false,
          hcpcs: product.productSubType.hcpcs,
          productSubTypeId: product.productSubType.id,
          productTypeId: product.productSubType.productTypeId,
          deliverable: true,
          billable: true,
          qty: quantity,
          points: Product.getPoints(
            product.productSubType,
            orderActivity.insuranceTypeId,
            mainContext.insuranceMatrixEntriesIndexed,
            mainContext.productMatrixEntriesIndexed,
          ),
          serial: "",
          amount:
            Product.getAmount(
              product.productSubType.hcpcs, //hcpcs code
              false, //isRental
              mainContext.hcpcsCodesIndexed,
              mainContext.feeSchedulesIndexed,
            ) ??
            product.msrp ??
            null,
          isRental: false,
          upgradedFromProductId: null,
        };
        orderActivityProductsObject[negativeId] = {
          orderActivityId: chartContext.orderId,
          productsId: negativeId,
        };
      });

      const approvalUpdate =
        getEquipmentPatientResponsibilityUpdate(productsObject);

      chartContext.onChange({
        ...(approvalUpdate || {}),
        product: productsObject,
        orderActivityProducts: orderActivityProductsObject,
      });

      setShouldSave(true);
    };

    return (
      <MUIBox sx={{ mt: 4 }}>
        <MUITypography variant="body1" sx={{ pb: 1 }}>
          Quotes
        </MUITypography>
        <MUIGrid container spacing={2}>
          {UploadedFile.sort(uploadedFiles).map((uploadedFile, index) => (
            <MUIGrid item xs={12} md={4} key={index + "uploadedFile"}>
              <TileUploadedFile
                key={index + "uploadedFile"}
                uploadedFile={uploadedFile}
                iconButtons={attachmentIconButtons(uploadedFile)}
                onClick={(e) => {
                  handlePdfViewer(uploadedFile);
                }}
              />
            </MUIGrid>
          ))}
        </MUIGrid>
        <DialogUploadQuote
          open={uploadQuoteDialogOpen}
          onClose={() => {
            setUploadQuoteDialogOpen(false);
            setUploadQuoteData(null);
          }}
          uploadQuoteData={uploadQuoteData}
          addingProducts={addingOrderProducts}
          isLoading={uploadingQuote}
          onConfirm={(products, overwriteExisting) =>
            handleApplyProducts(products, overwriteExisting)
          }
          onReprocess={() => handleReprocessQuote()}
        />
      </MUIBox>
    );
  };

  /**
   * Renders a alert for the DSWO button.
   * @returns {JSX.Element} MUIAlert component for DSWO alert
   */
  const renderDSWOOAlert = () => {
    if (showGenerateDswoButton && !enableGenerateDswoButton) {
      return (
        <>
          {dswoAlertMessages.map((message, index) => (
            <MUIAlert key={index} sx={{ mt: 1 }} severity="warning">
              {message}
            </MUIAlert>
          ))}
        </>
      );
    }
    return null;
  };

  const renderOrderApprovedAlert = () => {
    if (!editMode || !isOrderApproved) {
      return null;
    }

    return (
      <MUIAlert severity="info" sx={{ mb: 1, width: "100%" }}>
        This order has been approved and equipment cannot be edited. Unapprove
        in the Approval card to make changes.
      </MUIAlert>
    );
  };

  /**
   * Renders the content of the card.
   * @returns {JSX.Element} MUIBox component for card content
   */
  const renderContent = () => {
    return (
      <MUIBox>
        {renderOrderApprovedAlert()}
        {editMode && allowAdding && (
          <MUIGrid container spacing={2} sx={{ pt: 1, pb: 2 }}>
            <MUIGrid item xs={12} md={6} lg={4}>
              {renderCategoryDropdown()}
            </MUIGrid>
            <MUIGrid item xs={12} md={6} lg={4}>
              {renderProductDropdown()}
            </MUIGrid>
          </MUIGrid>
        )}
        {(!sortedOrderProducts || sortedOrderProducts.length === 0) &&
        !editMode ? (
          <EmptyState
            line1="No products"
            line2="Add a product to get started"
          />
        ) : (
          renderProductTable()
        )}
        {renderABNFields()}
        {renderDSWOOAlert()}
        {uploadedFiles.length > 0 && renderQuoteSection()}
      </MUIBox>
    );
  };

  /**
   * Returns the action buttons for the card component.
   * @returns {Array} Array of action button components
   */
  const getActions = () => {
    const handleCancel = () => {
      // Initialize revertedOrderActivityProducts to be only
      // orderActivityProduct rows for this orderActivity. If the row is
      // new, mark it for deletion by setting it to undefined.
      const productIds = [];
      const revertedOrderActivityProducts = {};
      Object.values(chartContext.chart.orderActivityProducts)
        .filter(
          (orderActivityProduct) =>
            orderActivityProduct.orderActivityId >= orderActivity.id,
        )
        .forEach((orderActivityProduct) => {
          productIds.push(orderActivityProduct.productsId);
          if (orderActivityProduct.productsId < 0) {
            revertedOrderActivityProducts[orderActivityProduct.productsId] =
              undefined;
          } else {
            revertedOrderActivityProducts[orderActivityProduct.productsId] = {
              ...orderActivityProduct,
            }; // Shallow clone
          }
        });

      // Initialize revertedProducts to be only product rows for this
      // orderActivity. If the row is new, mark it for deletion by setting
      // it to undefined.
      const revertedProducts = {};
      Object.values(chartContext.chart.product)
        .filter((product) => productIds.includes(product.id))
        .forEach((product) => {
          if (product.id < 0) {
            revertedProducts[product.id] = undefined;
          } else {
            revertedProducts[product.id] = { ...product }; // Shallow clone
          }
        });

      // Update revertedProducts to only contain the ID and any key that
      // has actually changed to avoid stomping over data other cards may
      // have changed.
      for (const id in revertedProducts) {
        const revertedProduct = revertedProducts[id];
        const originalProduct = chartContext.originalChart.product[id];

        for (const key in revertedProduct) {
          if (key !== "id" && revertedProduct[key] === originalProduct[key]) {
            delete revertedProduct[key];
          } else if (key === "deleted") {
            // This column doesn't really exist, so the way to undo
            // it is to set the value to undefined so the chart
            // update will remove that key.
            revertedProduct[key] = undefined;
          } else {
            revertedProduct[key] = originalProduct[key];
          }
        }
      }

      // Assume approval row exists, restore abnRequiredNote directly
      const orderActivityApprovals = Object.values(
        chartContext.chart.orderActivityApprovals || {},
      ).find(
        (orderActivityApproval) =>
          orderActivityApproval.orderActivityId === chartContext.orderId,
      );
      const approvalId = orderActivityApprovals.approvalsId;
      const originalApproval = chartContext.originalChart.approval[approvalId];
      const currentApproval = chartContext.chart.approval?.[approvalId];
      const currentPatientResponsibility =
        currentApproval?.patientResponsibility ?? null;

      const canRestorePatientResponsibility =
        equipmentTouchedPatientResponsibilityRef.current &&
        currentPatientResponsibility ===
          lastEquipmentSetPatientResponsibilityRef.current;

      const approvalUpdate = {
        abnRequiredNote: originalApproval.abnRequiredNote,
      };
      if (canRestorePatientResponsibility) {
        approvalUpdate.patientResponsibility =
          patientResponsibilityAtEditStartRef.current;
      }

      // Single onChange call with all updates
      chartContext.onChange({
        /**
         * Hardcoded these for simplicity. Because cardChart does not
         * have isolated sections per table, it gets weird trying to
         * find the things on the orderActivity that actually changed.
         *
         * This handles it for now, noting that as soon as we migrate
         * the cards to use cardChart for *everything* it will become
         * trivial to undo changes as this mostly goes away.
         */
        orderActivity: {
          [orderActivity.id]: {
            abnAmount:
              chartContext.originalChart.orderActivity[orderActivity.id]
                .abnAmount,
          },
        },
        orderActivityProducts: revertedOrderActivityProducts,
        product: revertedProducts,
        approval: {
          [approvalId]: {
            ...approvalUpdate,
          },
        },
      });

      const productFields = cardChart ? Object.keys(cardChart) : [];

      const clearedIssues = { ...chartContext.validationIssues };
      delete clearedIssues[className];
      chartContext.updateValidationIssues(clearedIssues);

      setSelectedProductType(null);
      setProductUpgradeOpen(false);
      setReceiveProductOpen(false);
      setIndexOfProductBeingReceived(null);
      setSelectedReceiveProductVendor(null);
      setProductBeingReceived(null);
      chartContext.setCardEditMode?.(className, false);
      setEditMode(false);
      resetEquipmentPatientResponsibilityTracking();
    };

    const handleGenerateDSWO = async () => {
      const data = {
        originalChart: chartContext.originalChart,
        orderId: orderActivity.id,
        orderProducts: sortedOrderProducts,
      };

      const pdfDswo = new PdfDswo(data);
      await pdfDswo.render();

      const patientName = Patient.getDisplayName(
        chartContext.chart.patient[chartContext.patientId],
      );
      const orderId = chartContext.orderId || "";
      const dateString = moment().format("YYYY-MM-DD");

      const filename =
        `DSWO - ${patientName} - ${orderId} - ${dateString}.pdf`.replace(
          /[\\/:*?"<>|]/g,
          "",
        );
      pdfDswo.document.save(filename);
    };

    const handleMarkAllProductsApproved = () => {
      const updates = {};
      sortedOrderProducts.forEach((product) => {
        if (!product.deleted) {
          updates[product.id] = { approved: true };
        }
      });
      chartContext.onChange({
        product: updates,
      });
    };

    // Use correct products for approval status depending on edit/view mode
    const allProductsApproved = modifiedProducts
      .filter((product) => !product.deleted)
      .every((product) => product.approved);

    // Generate menu items once
    const menuItems = [];
    if (allowApproving && editMode) {
      menuItems.push(
        <MUIMenuItem
          disabled={
            !allowApproving ||
            allProductsApproved ||
            orderActivity?.status === 3 ||
            isOrderApproved
          }
          onClick={handleMarkAllProductsApproved}
        >
          <MUIListItemIcon>
            <MUIDoneAllIcon fontSize="small" />
          </MUIListItemIcon>
          Approve all
        </MUIMenuItem>,
      );
    }
    if (showGenerateDswoButton && !editMode) {
      menuItems.push(
        <MUIMenuItem
          disabled={!enableGenerateDswoButton}
          onClick={() => handleGenerateDSWO()}
        >
          <MUIListItemIcon>
            <MUIFileDownloadIcon />
          </MUIListItemIcon>
          Generate DSWO
        </MUIMenuItem>,
      );
    }
    const menu = menuItems.length > 0 ? <Menu menuItems={menuItems} /> : <></>;

    if (sortedOrderProducts?.length === 0) {
      return [
        editMode ? (
          <MUIButton
            color="error"
            disabled={chartContext.isUpdating}
            onClick={() => {
              chartContext.setCardEditMode?.(className, false);
              setEditMode(false);
              handleCancel();
            }}
            startIcon={<MUIArrowBackIcon />}
            variant="outlined"
            size="small"
          >
            Cancel
          </MUIButton>
        ) : (
          <MUIButton
            disabled={chartContext.isUpdating}
            onClick={() => {
              beginEquipmentEditSession();
              setEditMode(true);
              setModifiedProducts(sortedOrderProducts);
            }}
            variant="outlined"
            startIcon={<MUIAddIcon />}
            size="small"
          >
            Add Product
          </MUIButton>
        ),
        menu,
      ];
    }

    return [
      ...(editMode
        ? [
            <MUIButton
              color="error"
              disabled={chartContext.isUpdating}
              onClick={() => handleCancel()}
              size="small"
            >
              Cancel
            </MUIButton>,
          ]
        : [
            <MUIButton
              disabled={chartContext.isUpdating}
              onClick={() => {
                beginEquipmentEditSession();
                setEditMode(true);
                setModifiedProducts(sortedOrderProducts);
              }}
              size="small"
            >
              Edit
            </MUIButton>,
          ]),
      menu, // Show menu if any items exist
    ];
  };

  return (
    <Card
      renderContent={renderContent}
      getActions={getActions}
      getTitle={() => title}
      getIcon={() => icon}
    />
  );
}

CardChartOrderEquipment.meta = {
  className: className,
  title: title,
  icon: icon,
};
